import { JoinTerms, JoinTermsDetail, TermsResponse } from "src/types/type"

export const convertTermsData = (termsData: TermsResponse<JoinTerms>): JoinTerms[] => {
  const termsResponseKeys = ['SKTTerms', 'KTTerms', 'LGUPTerms'] as const
  const copy = JSON.parse(JSON.stringify(termsData)) as TermsResponse<JoinTerms>

  for (const [key, value] of Object.entries(copy)) {
    if (termsResponseKeys.includes(key as keyof TermsResponse)) {
      value.Terms = value.Terms.map((terms: JoinTermsDetail, index: number) => ({
        ...terms,
        Required: terms.Required ?? 0,
        Order: parseInt(value.TermsOrder.charAt(index)),
      } as JoinTermsDetail))
    }
  }
  return [
    copy.SKTTerms,
    copy.KTTerms,
    copy.LGUPTerms
  ]
}
